export const DAYS_IN_WEEK = 7;
